import type { AnalyticsEventName, AnalyticsEventPayload } from '@bevpass/types';
import { analyticsEventNames } from '@bevpass/types';
import { logAnalyticsEvent, setAnalyticsIdentity, setAnalyticsUserProperties } from '@/lib/firebase';

const allowedEvents = new Set<string>(analyticsEventNames);

const ensureValidEvent = (event: AnalyticsEventName) => {
  if (!allowedEvents.has(event)) {
    throw new Error(`Unknown analytics event: ${event}`);
  }
};

export const trackAnalyticsEvent = async (event: AnalyticsEventName, params?: AnalyticsEventPayload) => {
  ensureValidEvent(event);
  await logAnalyticsEvent(event, params);
};

export const trackAdminAction = async (
  action: string,
  params?: AnalyticsEventPayload & { actorId?: string; actorEmail?: string },
) => {
  await logAnalyticsEvent('admin_action', {
    action,
    ...params,
  });
};

export const setAnalyticsUser = async (userId: string | null) => {
  await setAnalyticsIdentity(userId);
};

export const setAnalyticsProperties = async (
  properties: Record<string, string | number | boolean | null | undefined>,
) => {
  await setAnalyticsUserProperties(properties);
};
